/*!

 =========================================================
 * Vue Black Dashboard PRO - v1.2.1
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-kit-pro
 * Copyright 2019 Creative Tim (https://www.creative-tim.com)

 * Coded by Creative Tim

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import RouterPrefetch from 'vue-router-prefetch'
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
import store from './store';
import firebase from 'firebase/app';
import 'firebase/auth';
import VueCurrencyFilter from 'vue-currency-filter'
import VueSweetalert2 from 'vue-sweetalert2';

// router setup
import router from './routes/router';
import i18n from './i18n';
//import './registerServiceWorker'
import moment from 'moment';

// Bugsnag
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'


import VueMeta from 'vue-meta'

Bugsnag.start({
  apiKey: '7dfe6120d77b02e95977b48d9c7ebf87',
  plugins: [new BugsnagPluginVue()],
  appVersion: process.env.PACKAGE_VERSION
})

moment.locale('fr', {
  months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
  monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
  monthsParseExact : true,
  weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
  weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
  weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
  weekdaysParseExact : true,
  longDateFormat : {
      LT : 'HH:mm',
      LTS : 'HH:mm:ss',
      L : 'DD/MM/YYYY',
      LL : 'D MMMM YYYY',
      LLL : 'D MMMM YYYY HH:mm',
      LLLL : 'dddd D MMMM YYYY HH:mm'
  },
  calendar : {
      sameDay : '[Aujourd’hui à] LT',
      nextDay : '[Demain à] LT',
      nextWeek : 'dddd [à] LT',
      lastDay : '[Hier à] LT',
      lastWeek : 'dddd [dernier à] LT',
      sameElse : 'L'
  },
  relativeTime : {
      future : 'dans %s',
      past : 'il y a %s',
      s : 'quelques secondes',
      m : 'une minute',
      mm : '%d minutes',
      h : 'une heure',
      hh : '%d heures',
      d : 'un jour',
      dd : '%d jours',
      M : 'un mois',
      MM : '%d mois',
      y : 'un an',
      yy : '%d ans'
  },
  dayOfMonthOrdinalParse : /\d{1,2}(er|e)/,
  ordinal : function (number) {
      return number + (number === 1 ? 'er' : 'e');
  },
  meridiemParse : /PD|MD/,
  isPM : function (input) {
      return input.charAt(0) === 'M';
  },
  // In case the meridiem units are not separated around 12, then implement
  // this function (look at locale/id.js for an example).
  // meridiemHour : function (hour, meridiem) {
  //     return /* 0-23 hour, given meridiem token and hour 1-12 */ ;
  // },
  meridiem : function (hours, minutes, isLower) {
      return hours < 12 ? 'PD' : 'MD';
  },
  week : {
      dow : 1, // Monday is the first day of the week.
      doy : 4  // Used to determine first week of the year.
  }
});

moment.locale('fr');
Vue.prototype.$moment = moment;

Vue.prototype.$currency = (marketOrMode) => {
  if( marketOrMode === 'CC' ) return '$';
  if( marketOrMode === 'crypto' ) return '$';
  if( marketOrMode === 'US' ) return '$';
  if( marketOrMode === 'usa' ) return '$';
  return '€';
};

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueSweetalert2);
Vue.use(VueRouter);
Vue.use(RouterPrefetch);
Vue.use(VueMeta)
Vue.use(VueCurrencyFilter, {
  symbol : '€',
  thousandsSeparator: '.',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'back',
  symbolSpacing: false
})
// Bugsnag
Bugsnag.getPlugin('vue')
  .installVueErrorHandler(Vue)


/* eslint-disable no-new */
const check = firebase.auth().onAuthStateChanged(async (user) => {
  new Vue({
    el: '#app',
    render: h => h(App),
    router,
    store,
    i18n,
    moment,
    created() {
      if (user) {
        store.dispatch('auth/autoSignIn', user)
      }
    }
  })
  check()
})

const ignoreWarnMessage = 'The .native modifier for v-on is only valid on components but it was used on <a>.';
Vue.config.warnHandler = function (msg, vm, trace) {
  // `trace` is the component hierarchy trace
  if (msg === ignoreWarnMessage) {
    msg = null;
    vm = null;
    trace = null;
  }
}
